var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { useBreakpointContext } from "./BreakpointContextProvider";
var IsMobileContext = createContext(false);
export var useIsMobileContext = function () {
    var context = useContext(IsMobileContext);
    if (context === null) {
        throw new Error('useIsMobileContext must be used within an IsMobileContext');
    }
    return context;
};
export function IsMobileContextProvider(props) {
    var breakpoint = useBreakpointContext();
    var _a = useState(breakpoint === "xs" || breakpoint === "sm"), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        setIsMobile(breakpoint === "xs" || breakpoint === "sm");
    }, [breakpoint]);
    return (_jsx(IsMobileContext.Provider, __assign({ value: isMobile }, { children: props.children })));
}
